import { FormGroup, Row, Col, FormFeedback, Input } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import SelectField from "../Utils/SelectField";
import "react-phone-number-input/style.css";
import {
  handleChangeForCity,
  handleChangeForCountry,
  handleChangeForImsi,
  handleChangeForName,
  handleChangeForState,
} from "./constants/HandleChangeFunctions";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useState } from "react";
import {
  dialCodeFocusChange,
  validatePhoneNumber,
} from "./constants/DocumentTableFunctions";
import { CreatableSelectField } from "../Utils/CreatableSelectField";
import {
  handleFileChange,
  removeProfilePicture,
} from "./constants/constantFunctions";
import { useSelector } from "react-redux";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { ImageUpload } from "../Utils/ImageUpload";
export default function CustomerDetails({
  values,
  touched,
  errors,
  setFieldTouched,
  setFieldValue,
  initialValues,
  handleChange,
  handleBlur,
  options,
  optionState,
  dialCode,
  setDialCode,
  optionCity,
  cityData,
  onfocus,
  setOnFocus,
  setSelectedCountry,
  setSelectedState,
  setSelectedCity,
  bdomOptions,
  setCities,
  customerPermission,
  isEdit,
  isProfile,
  setIsProfile,
  profilePicture,
  setProfilePicture,
  inputFileRef,
  dispatch,
  setLoading,
  setUpdate,
  customerId,
  setFileSelected,
  documentName,
}) {
  const [validateSizeError, setValidateSizeError] = useState(null);
  const handleSSOToggle = (e) => {
    setFieldValue("isSSOUser", e.target.checked);
  };
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );
  // const isEIPEnabled =
  //   operatorConfiguration?.configurations
  //     ?.find((config) => config.name === "EIP")
  //     ?.value?.find((item) => item.key === "Enabled")?.value?.[0] === "True";
   const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

  const environment = localStorage.getItem("environment");
  const isNativeEnvironment = environment === "Native";
  return (
    <>
      <Row className="gy-4 pt-4">
        <Col xxl={3} md={12} className="pe-3">
          {/* <FormGroup>
            <div className="image-div-tag">
              <LabelText
                htmlFor={"logo"}
                classLabelName={"ms-0 rv-form-label"}
                displayText={"Photo Upload"}
              />
              <LabelText
                htmlFor={"logo"}
                classLabelName={`d-block ms-0 rv-sub-label ${validateSizeError ? "rv-label-danger" : "rv-label-muted"
                  } `}
                displayText={
                  validateSizeError
                    ? validateSizeError
                    : "JPEG, PNG, SVG format, upto 10 MB"
                }
              />
              <div className="image-border-style ms-0">
                {profilePicture ? (
                  <>
                    <img
                      src={
                        isProfile
                          ? URL.createObjectURL(profilePicture)
                          : profilePicture
                      }
                      alt="Logo Preview"
                      className="to-img-tag"
                    />
                    <button
                      onClick={() =>
                        removeProfilePicture(
                          dispatch,
                          setLoading,
                          setProfilePicture,
                          setIsProfile,
                          inputFileRef,
                          documentName,
                          isEdit,
                          customerId,
                          setUpdate
                        )
                      }
                      className="img-remove-button"
                    >
                      <span className="x-mark">×</span>
                    </button>
                  </>
                ) : (
                  <>
                    <label htmlFor="logoInput" className="cursor-img">
                      <FileUploadOutlinedIcon
                        className="fs-1 align-middle me-1 text-secondary"
                        style={{ transform: "rotate(0deg)" }}
                      />
                    </label>
                  </>
                )}

                <input
                  type="file"
                  id="logoInput"
                  name="logo"
                  accept=".jpg, .jpeg, .png"
                  style={{ display: "none" }}
                  onChange={(e) =>
                    handleFileChange(
                      e,
                      setIsProfile,
                      setProfilePicture,
                      setFileSelected,
                      setValidateSizeError
                    )
                  }
                  ref={inputFileRef}
                />
              </div>
            </div>
          </FormGroup> */}
          <ImageUpload
            validateSizeError={validateSizeError}
            profilePicture={profilePicture}
            isProfile={isProfile}
            inputFileRef={inputFileRef}
            removeProfilePicture={() => {
              removeProfilePicture(
                dispatch,
                setLoading,
                setProfilePicture,
                setIsProfile,
                inputFileRef,
                documentName,
                isEdit,
                customerId,
                setUpdate
              )
            }}
            handleImageChange={(e) => {
              handleFileChange(
                e,
                setIsProfile,
                setProfilePicture,
                setFileSelected,
                setValidateSizeError
              )

            }}
          ></ImageUpload>
        </Col>
        <Col xxl={9} md={12} className="ps-0">
          <Row className="pe-2">
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <FormGroup>
                  <LabelText
                    htmlFor={"firstName"}
                    classLabelName={"ms-0 rv-form-label"}
                    className={"text-danger"}
                    displayText={"First Name"}
                    important={"*"}
                  />
                  <LabelText
                    htmlFor={"firstName"}
                    classLabelName={`d-block ms-0 rv-sub-label ${touched.firstName && errors.firstName
                        ? "rv-label-danger"
                        : "rv-label-muted"
                      } `}
                    displayText={
                      touched.firstName && errors.firstName
                        ? errors.firstName
                        : `Enter ${isEIPEnabled ? "Device" : "Customer"
                        }'s First Name`
                    }
                  />
                  <InputField
                    name={"firstName"}
                    // placeholder={"Enter your First Name"}
                    type={"text"}
                    className={"form-control"}
                    id={"firstName"}
                    handleChange={handleChangeForName(
                      setFieldValue,
                      "firstName"
                    )}
                    handleBlur={handleBlur}
                    value={values.firstName}
                    invalid={
                      touched.firstName && errors.firstName ? true : false
                    }
                  />
                  {/* {touched.firstName && errors.firstName ? (
                    <FormFeedback type="invalid">
                      {errors.firstName}
                    </FormFeedback>
                  ) : null} */}
                </FormGroup>
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <FormGroup>
                  <LabelText
                    htmlFor={"lastName"}
                    classLabelName={"ms-0 rv-form-label"}
                    className={"text-danger"}
                    displayText={"Last Name"}
                    important={"*"}
                  />
                  <LabelText
                    htmlFor={"lastName"}
                    classLabelName={`d-block ms-0 rv-sub-label ${touched.lastName && errors.lastName
                        ? "rv-label-danger"
                        : "rv-label-muted"
                      } `}
                    displayText={
                      touched.lastName && errors.lastName
                        ? errors.lastName
                        : `Enter ${isEIPEnabled ? "Device" : "Customer"
                        }'s Last Name`
                    }
                  />
                  <InputField
                    name={"lastName"}
                    // placeholder={"Enter your Last Name"}
                    type={"text"}
                    className={"form-control"}
                    id={"lastName"}
                    handleChange={handleChangeForName(
                      setFieldValue,
                      "lastName"
                    )}
                    handleBlur={handleBlur}
                    value={values.lastName}
                    invalid={touched.lastName && errors.lastName ? true : false}
                  />
                  {/* {touched.lastName && errors.lastName ? (
                    <FormFeedback type="invalid">
                      {errors.lastName}
                    </FormFeedback>
                  ) : null} */}
                </FormGroup>
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <FormGroup>
                  <LabelText
                    htmlFor={"userName"}
                    classLabelName={"ms-0 rv-form-label"}
                    className={"text-danger"}
                    displayText={"User Name"}
                    important={"*"}
                  />
                  <LabelText
                    htmlFor={"userName"}
                    classLabelName={`d-block ms-0 rv-sub-label ${touched.userName && errors.userName
                        ? "rv-label-danger"
                        : "rv-label-muted"
                      } `}
                    displayText={
                      touched.userName && errors.userName
                        ? errors.userName
                        : `Enter ${isEIPEnabled ? "Device" : "Customer"
                        }'s User Name`
                    }
                  />
                  <InputField
                    name={"userName"}
                    // placeholder={"Enter your User Name"}
                    type={"text"}
                    className={"form-control"}
                    id={"userName"}
                    handleChange={handleChange}
                    disabled={isEdit ? true : false}
                    handleBlur={handleBlur}
                    value={values.userName}
                    invalid={touched.userName && errors.userName ? true : false}
                  />
                  {/* {touched.userName && errors.userName ? (
                    <FormFeedback type="invalid">
                      {errors.userName}
                    </FormFeedback>
                  ) : null} */}
                </FormGroup>
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <FormGroup>
                  <LabelText
                    htmlFor={"email"}
                    classLabelName={"ms-0 rv-form-label"}
                    className={"text-danger"}
                    displayText={"Email Address"}
                    important={"*"}
                  />
                  <LabelText
                    htmlFor={"email"}
                    classLabelName={`d-block ms-0 rv-sub-label ${touched.email && errors.email
                        ? "rv-label-danger"
                        : "rv-label-muted"
                      } `}
                    displayText={
                      touched.email && errors.email
                        ? errors.email
                        : `Enter ${isEIPEnabled ? "Device" : "Customer"
                        }'s Email Address`
                    }
                  />
                  <InputField
                    name={"email"}
                    // placeholder={"Enter your Email"}
                    type={"text"}
                    className={"form-control"}
                    id={"email"}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.email}
                    invalid={touched.email && errors.email ? true : false}
                  />
                  {/* {touched.email && errors.email ? (
                    <FormFeedback type="invalid">{errors.email}</FormFeedback>
                  ) : null} */}
                </FormGroup>
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <FormGroup>
                  <LabelText
                    htmlFor={"mobile"}
                    classLabelName={"ms-0 rv-form-label"}
                    className={"text-danger"}
                    displayText={"Phone Number"}
                    important={"*"}
                  />
                  <LabelText
                    htmlFor={"mobile"}
                    classLabelName={`d-block ms-0 rv-sub-label ${onfocus && validatePhoneNumber(dialCode)
                        ? "rv-label-danger"
                        : "rv-label-muted"
                      } `}
                    displayText={
                      onfocus && validatePhoneNumber(dialCode)
                        ? validatePhoneNumber(dialCode)
                        : `Enter ${isEIPEnabled ? "Device" : "Customer"
                        }'s Phone Number`
                    }
                  />
                  <PhoneInput
                    international
                    countryCallingCodeEditable={false}
                    className={` ${onfocus &&
                        dialCode === "" &&
                        !isValidPhoneNumber(dialCode)
                        ? "error-input "
                        : "form-control"
                      } ps-3`}
                    // placeholder={"Enter your Phone Number"}
                    onChange={setDialCode}
                    onFocus={() => dialCodeFocusChange(setOnFocus)}
                    value={dialCode}
                  />
                  {/* {onfocus && (
                    <div className="text-danger validation-font-size">
                      {validatePhoneNumber(dialCode)}
                    </div>
                  )} */}
                </FormGroup>
              </div>
            </Col>
            {customerPermission?.has("autoload") && (
              <Col xxl={4} md={6} className="pe-0">
                <div>
                  <FormGroup>
                    <LabelText
                      htmlFor={"accountNumber"}
                      classLabelName={"ms-0 rv-form-label"}
                      className={"text-danger"}
                      displayText={"Account Number"}
                    />
                    <LabelText
                      htmlFor={"accountNumber"}
                      classLabelName={`d-block ms-0 rv-sub-label ${touched.accountNumber && errors.accountNumber
                          ? "rv-label-danger"
                          : "rv-label-muted"
                        } `}
                      displayText={
                        touched.accountNumber && errors.accountNumber
                          ? errors.accountNumber
                          : `Enter ${isEIPEnabled ? "Device" : "Customer"
                          }'s Account Number`
                      }
                    />
                    <InputField
                      name={"accountNumber"}
                      //   placeholder={"Enter your Account Number"}
                      type={"text"}
                      className={"form-control"}
                      id={"accountNumber"}
                      handleChange={handleChange}
                      disabled={isEdit}
                      maxLength="32"
                      handleBlur={handleBlur}
                      value={values.accountNumber}
                      invalid={
                        touched.accountNumber && errors.accountNumber
                          ? true
                          : false
                      }
                    />
                    {/* {touched.accountNumber && errors.accountNumber ? (
                      <FormFeedback type="invalid">
                        {errors.accountNumber}
                      </FormFeedback>
                    ) : null} */}
                  </FormGroup>
                </div>
              </Col>
            )}
            <Col xxl={4} md={6} className="pe-0">
              <FormGroup>
                <LabelText
                  htmlFor={"bdom"}
                  classLabelName={"ms-0 rv-form-label"}
                  className={"text-danger"}
                  displayText={"BDOM"}
                  important={"*"}
                />
                <LabelText
                  htmlFor={"bdom"}
                  classLabelName={`d-block ms-0 rv-sub-label ${touched.bdom && errors.bdom
                      ? "rv-label-danger"
                      : "rv-label-muted"
                    } `}
                  displayText={
                    touched.bdom && errors.bdom
                      ? errors.bdom
                      : `Select BDOM (Billing Day of Month)`
                  }
                />
                <SelectField
                  className={
                    (errors.bdom && touched.bdom) || false ? "error-input" : ""
                  }
                  value={values.bdom}
                  placeholder={" "}
                  handleChange={(value) => {
                    setFieldValue("bdom", value);
                  }}
                  options={[...bdomOptions]}
                  isRVStyle={true}
                />
                {/* {touched.bdom && errors.bdom ? (
                  <p className="text-danger validation-font-size">
                    {errors.bdom}
                  </p>
                ) : null} */}
              </FormGroup>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <FormGroup>
                  <LabelText
                    htmlFor={"addressLine1"}
                    classLabelName={"ms-0 rv-form-label"}
                    className={"text-danger"}
                    displayText={"Address"}
                    important={"*"}
                  />
                  <LabelText
                    htmlFor={"addressLine1"}
                    classLabelName={`d-block ms-0 rv-sub-label ${touched.addressLine1 && errors.addressLine1
                        ? "rv-label-danger"
                        : "rv-label-muted"
                      } `}
                    displayText={
                      touched.addressLine1 && errors.addressLine1
                        ? errors.addressLine1
                        : `Enter ${isEIPEnabled ? "Device" : "Customer"
                        }'s Address`
                    }
                  />
                  <InputField
                    name={"addressLine1"}
                    // placeholder={"Enter your Address"}
                    type={"text"}
                    className={"form-control"}
                    id={"addressLine1"}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.addressLine1}
                    invalid={
                      touched.addressLine1 && errors.addressLine1 ? true : false
                    }
                  />
                  {/* {touched.addressLine1 && errors.addressLine1 ? (
                    <FormFeedback type="invalid">
                      {errors.addressLine1}
                    </FormFeedback>
                  ) : null} */}
                </FormGroup>
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <LabelText
                  htmlFor={"addressLine2"}
                  classLabelName={"ms-0 rv-form-label"}
                  className={"text-danger"}
                  displayText={"Address 2"}
                />
                <LabelText
                  htmlFor={"addressLine2"}
                  classLabelName={"d-block ms-0 rv-sub-label rv-label-muted"}
                  displayText={`Enter ${isEIPEnabled ? "Device" : "Customer"
                    }'s Address 2`}
                />
                <InputField
                  name={"addressLine2"}
                  //   placeholder={"Enter your Address 2"}
                  type={"text"}
                  className={"form-control"}
                  id={"addressLine2"}
                  handleChange={handleChange}
                  value={values.addressLine2}
                />
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <LabelText
                  htmlFor={"choices-single-default"}
                  classLabelName={"ms-0 rv-form-label"}
                  className={"text-danger"}
                  displayText={"Country"}
                  important={"*"}
                />
                <LabelText
                  htmlFor={"choices-single-default"}
                  displayText={"Select Your Country"}
                  classLabelName={`d-block ms-0 rv-sub-label ${touched.country && errors.country
                      ? "rv-label-danger"
                      : "rv-label-muted"
                    } `}
                />
                <SelectField
                  className={
                    (errors.country && touched.country) || false
                      ? "error-input"
                      : ""
                  }
                  value={
                    initialValues.country
                      ? options?.filter((country) => {
                        country.label === initialValues.country;
                      })
                      : values.country
                  }
                  placeholder={" "}
                  handleChange={handleChangeForCountry(
                    setSelectedCountry,
                    setFieldValue,
                    setFieldTouched,
                    setSelectedState,
                    setSelectedCity,
                    setCities
                  )}
                  isClearable={true}
                  options={[...options]}
                  isRVStyle={true}
                />
                {/* {touched.country && errors.country ? (
                  <p className="text-danger validation-font-size">
                    {errors.country}
                  </p>
                ) : null} */}
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <FormGroup>
                  <LabelText
                    htmlFor={"choices-single-default"}
                    classLabelName={"ms-0 rv-form-label"}
                    className={"text-danger"}
                    displayText={"State"}
                    important={"*"}
                  />
                  <LabelText
                    htmlFor={"choices-single-default"}
                    classLabelName={`d-block ms-0 rv-sub-label ${touched.state && errors.state
                        ? "rv-label-danger"
                        : "rv-label-muted"
                      } `}
                    displayText={"Select Your State"}
                  />
                  <SelectField
                    className={
                      errors.state && touched.state ? "error-input" : ""
                    }
                    value={
                      initialValues.state
                        ? optionState?.filter((state) => {
                          state.label === initialValues.state;
                        })
                        : values.state
                    }
                    placeholder=" "
                    handleChange={handleChangeForState(
                      setSelectedState,
                      setFieldValue
                    )}
                    options={[...optionState]}
                    isClearable={true}
                    isDisabled={!values.country}
                    isRVStyle={true}
                  />
                  {/* {touched.state && errors.state ? (
                    <p className="text-danger validation-font-size">
                      {errors.state}
                    </p>
                  ) : null} */}
                </FormGroup>
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <LabelText
                  htmlFor={"choices-single-default"}
                  classLabelName={"ms-0 rv-form-label"}
                  className={"text-danger"}
                  displayText={"City"}
                  important={"*"}
                />
                <LabelText
                  htmlFor={"choices-single-default"}
                  classLabelName={`d-block ms-0 rv-sub-label ${touched.city && errors.city
                      ? "rv-label-danger"
                      : "rv-label-muted"
                    } `}
                  displayText={"Select Your City"}
                />
                <SelectField
                  className={
                    (errors.city && touched.city) || false ? "error-input" : ""
                  }
                  values={values.city}
                  placeholder={" "}
                  handleChange={(value) => {
                    setFieldValue(`city`, value, false);
                    setFieldTouched(`city`, false);
                  }}
                  onKeyDown={(event) => {
                    const key = event.key;
                    const regex = /^[a-zA-Z0-9]$/;
                    if (
                      regex.test(key) ||
                      [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Enter",
                      ].includes(key)
                    ) {
                      return;
                    }
                    event.preventDefault();
                  }}
                  name={"city"}
                  options={optionCity}
                  fieldName={"city"}
                  setFieldValue={setFieldValue}
                  // errors={errors.city}
                  isClearable={true}
                  isDisabled={!values.state}
                  handleBlur={handleBlur}
                  touched={touched.city}
                  isRVStyle={true}
                />
              </div>
            </Col>
            <Col xxl={4} md={6} className="pe-0">
              <div>
                <FormGroup>
                  <LabelText
                    htmlFor={"zipCode"}
                    classLabelName={"ms-0 rv-form-label"}
                    className={"text-danger"}
                    displayText={"Zip Code"}
                    important={"*"}
                  />
                  <LabelText
                    htmlFor={"zipCode"}
                    classLabelName={`d-block ms-0 rv-sub-label ${touched.zipCode && errors.zipCode
                        ? "rv-label-danger"
                        : "rv-label-muted"
                      } `}
                    displayText={
                      touched.zipCode && errors.zipCode
                        ? errors.zipCode
                        : "Enter Your Zip Code"
                    }
                  />
                  <InputField
                    name={"zipCode"}
                    // placeholder={"Enter your Zip Code"}
                    type={"number"}
                    className={"form-control"}
                    id={"zipCode"}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.zipCode}
                    invalid={touched.zipCode && errors.zipCode ? true : false}
                  />
                  {/* {touched.zipCode && errors.zipCode ? (
                    <FormFeedback type="invalid">{errors.zipCode}</FormFeedback>
                  ) : null} */}
                </FormGroup>
              </div>
            </Col>
            {!isNativeEnvironment ? (
              <Col xxl={4} md={6} className="pe-0">
                <div>
                  <FormGroup>
                    <LabelText
                      htmlFor={"sso"}
                      classLabelName={"ms-0 rv-form-label"}
                      className={"text-danger"}
                      displayText={"SSO"}
                    />
                     <LabelText
                      htmlFor={"sso"}
                      classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                      displayText={
                        "Enable / Disable SSO"
                      }
                    />
                    <div className="d-flex align-items-center mt-3">
                      <FormGroup switch>
                        <Input
                          type={"switch"}
                          className="rv-form-switch-input"
                          name="isSSOUser"
                          checked={values.isSSOUser || false}
                          onChange={handleSSOToggle}
                          disabled={isEdit}
                        />
                      </FormGroup>
                    </div>
                  </FormGroup>
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>
    </>
  );
}
